const loadGoogleMapsApi = require('load-google-maps-api');

const mapContainer = document.querySelector('#map');

if (mapContainer) {
    loadGoogleMapsApi({
        key: 'AIzaSyDCwUXMqUrNyd8nvSsZj_V_FuZx2TNbXdU'
    }).then(function (googleMaps) {
        const map = new googleMaps.Map(mapContainer, {
            center: {
                lat: 50.586419915642324,
                lng: 15.142727475656805,
            },
            zoom: 15,
            styles: [{
                featureType: 'poi',
                stylers: [{
                    visibility: 'off'
                }],
            }],
        });

        let markers = Array;
        markers[0] = new googleMaps.Marker({
            position: {
                lat: 50.586419915642324,
                lng: 15.142727475656805,
            },
            map: map,
        });

        const window = new googleMaps.InfoWindow();
    }).catch(function (error) {
        console.error(error)
    });
}
